import { Dispatch, SetStateAction } from 'react';
import Select from 'react-select';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form';
import { useLicenceDetailsForm } from '@/redux/post/usePostForm';
import SectionHeader from '@/components/FullPageCarousel/SectionHeader';
import ErrorMessage from '@/components/ErrorMessage';
import { ILicense, IPostUploadData } from '@/redux/post/post.d';
import LicenseDetailsCard from '@/pages/PostDetail/LicenseDetailsCard';

function LicenceDetails({
  formData,
  errors,
  setFormData,
}: {
  formData: IPostUploadData;
  errors: { [key: string]: string };
  setFormData: Dispatch<SetStateAction<IPostUploadData>>;
}) {
  const licenceDetailsForm = useLicenceDetailsForm(formData);

  const handleSelectChange = (name: string, value: string) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const licenceTypeOptions = Object.values(ILicense);

  return (
    <div className="space-y-6">
      <SectionHeader
        title="Licence Details"
        description="Enter licence details for your project."
      />
      <div className="space-y-4">
        <Form {...licenceDetailsForm}>
          <form>
            <div className="flex flex-col py-2 gap-2">
              <div className="flex flex-col gap-2">
                <FormField
                  control={licenceDetailsForm.control}
                  name="licenceType"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Licence Type</FormLabel>
                      <FormControl>
                        <Select
                          options={licenceTypeOptions.map((option) => ({
                            label: option,
                            value: option,
                          }))}
                          onChange={(selectedOption) => {
                            if (selectedOption?.value) {
                              handleSelectChange(
                                field.name,
                                selectedOption.value
                              );
                            }
                          }}
                          isSearchable
                          name={field.name}
                          value={{
                            label: licenceTypeOptions.filter(
                              (model) => model === formData.licenceType
                            ) as unknown as string,
                            value: licenceTypeOptions.filter(
                              (model) => model === formData.licenceType
                            ) as unknown as string,
                          }}
                        />
                      </FormControl>
                      <ErrorMessage error={errors.licenceType} />
                    </FormItem>
                  )}
                />
              </div>
              <LicenseDetailsCard post={formData} />
            </div>
          </form>
        </Form>
      </div>
    </div>
  );
}

export default LicenceDetails;
